import { createSelector } from 'reselect';
import { get, set, isEmpty } from 'lodash';

import { fieldTypes } from 'shared/components/DynamicForm/fieldTypes';
import {
  EMPTY_TEXT_FIELD,
  EMPTY_SELECT_FIELD,
  localErrorMessagesMap,
} from 'modules/appointmentsManagement/constants/localErrorCodes';

export const getCaseSummaryInputConfig = state => get(state, 'appointmentInfo.caseData.caseDataForm.form', []);

export const getFormInitialValues = createSelector(
  [getCaseSummaryInputConfig],
  (formConfig) => {
    if (isEmpty(formConfig)) return undefined;

    const reducer = (acc, curr) => {
      if (curr.type === fieldTypes.FIELDSET && curr.elements.length) {
        curr.elements.reduce(reducer, acc);
      } else if (curr.value) {
        set(acc, curr.path, curr.value);
      }

      return acc;
    };

    return formConfig.reduce(reducer, {});
  },
);

const getFieldName = fieldType => {
  switch (fieldType) {
    case fieldTypes.SELECT:
      return EMPTY_SELECT_FIELD;
    default:
      return EMPTY_TEXT_FIELD;
  }
};

export const getValidationConfig = createSelector(
  [getCaseSummaryInputConfig],
  (formConfig) => {
    if (!formConfig) return undefined;

    const result = { rules: {}, errorMessages: {}, attributeLabels: {} };

    const reducer = (acc, curr) => {
      if (curr.type === fieldTypes.FIELDSET && curr.elements.length) {
        curr.elements.reduce(reducer, acc);
      } else if (curr.validation) {
        const rules = [];
        if (curr.validation.isRequired) {
          rules.push('required');
          acc.errorMessages[`required.${ curr.path }`] = localErrorMessagesMap[getFieldName(curr.type)];
        }
        if (curr.validation.minLength) rules.push(`min:${ curr.validation.minLength }`);
        if (curr.validation.maxLength) rules.push(`max:${ curr.validation.maxLength }`);

        acc.rules[curr.path] = rules;
        acc.attributeLabels[curr.path] = curr.name;
      }

      return acc;
    };

    return formConfig.reduce(reducer, result);
  },
);
